import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { useFavorites } from "../context/FavoritesContext"
import { useAuth } from "../context/AuthContext"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import FavoriteButton from "../components/FavoriteButton"

const UserFavoritesPage = () => {
  const { user } = useAuth()
  const { favoriteTemples, loading, error, loadFavorites } = useFavorites()
  const [activeTab, setActiveTab] = useState("temples")

  if (!user) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-divine-50 via-white to-sacred-50">
        <Navbar />
        <div className="container mx-auto px-4 py-16 text-center">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">Please Login to View Your Favorites</h1>
          <p className="text-gray-600 mb-8">
            You need to be logged in to access your favorite temples.
          </p>
          <Link
            to="/login?redirect=favorites"
            className="bg-spiritual-600 hover:bg-spiritual-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
          >
            Login Now
          </Link>
        </div>
        <Footer />
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-divine-50 via-white to-sacred-50">
      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-spiritual-700 mb-8">Your Favorites</h1>

        {/* Tabs */}
        <div className="flex border-b border-gray-200 mb-8">
          <button
            onClick={() => setActiveTab("temples")}
            className={`py-3 px-6 font-medium ${
              activeTab === "temples"
                ? "border-b-2 border-spiritual-600 text-spiritual-700"
                : "text-gray-500 hover:text-spiritual-600"
            }`}
          >
            Temples
          </button>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-spiritual-600 mb-2"></div>
            <p className="text-gray-600">Loading your favorites...</p>
          </div>
        ) : error ? (
          <div className="text-center py-12 text-red-600">
            <p>{error}</p>
            <button
              onClick={loadFavorites}
              className="mt-4 bg-spiritual-600 hover:bg-spiritual-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors"
            >
              Try Again
            </button>
          </div>
        ) : (
          <>
            {/* Temples Tab */}
            {activeTab === "temples" && (
              <div>
                {favoriteTemples.length === 0 ? (
                  <div className="text-center py-12">
                    <div className="text-6xl text-gray-300 mb-4">🕉️</div>
                    <h3 className="text-2xl font-bold text-gray-700 mb-2">No Favorite Temples Yet</h3>
                    <p className="text-gray-600 mb-6">
                      You haven't added any temples to your favorites. Explore temples and click the heart icon to add
                      them here.
                    </p>
                    <Link
                      to="/temple"
                      className="bg-spiritual-600 hover:bg-spiritual-700 text-white px-6 py-2 rounded-lg text-sm font-semibold transition-colors"
                    >
                      Explore Temples
                    </Link>
                  </div>
                ) : (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {favoriteTemples.map((temple) => (
                      <div
                        key={temple._id}
                        className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300"
                      >
                        <div className="relative">
                          <Link to={`/temple/${temple._id}`}>
                            <img
                              src={temple.mainImage || "/placeholder.svg?height=300&width=400"}
                              alt={temple.name}
                              className="w-full h-48 object-cover"
                            />
                          </Link>
                          <div className="absolute top-2 right-2">
                            <FavoriteButton
                              itemId={temple._id}
                              itemType="temple"
                              className="bg-white/80 hover:bg-white"
                            />
                          </div>
                        </div>
                        <div className="p-4">
                          <Link to={`/temple/${temple._id}`}>
                            <h3 className="text-xl font-semibold text-spiritual-700 mb-1">{temple.name}</h3>
                            <div className="flex items-center text-gray-600 mb-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4 mr-1"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                              </svg>
                              {temple.location?.address}, {temple.location?.city}, {temple.location?.state}
                            </div>
                            <p className="text-sacred-600 mb-3">{temple.deity}</p>
                            <p className="text-gray-600 text-sm line-clamp-2">{temple.description}</p>
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

          </>
        )}
      </div>

      <Footer />
    </div>
  )
}

export default UserFavoritesPage
